<template>
  <div>
    <!-- div v-if="isDialogOpened" class="background"></div -->
    <v-dialog
      v-model="isDialogOpened"
      :fullscreen="fullscreen"
      :persistent="persistent"
      :scrollable="scrollable"
      :width="width"
      @click:outside="$emit('handleCloseDialog')"
    >
      <slot />
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CommonDialog",
  props: {
    persistent: {
      type: Boolean,
      default: false
    },
    isDialogOpened: {
      type: Boolean,
      required: true
    },
    scrollable: {
      type: Boolean,
      default: false,
      required: false
    },
    width: {
      type: String,
      default: "1000px"
    },
    fullscreen: {
      type: Boolean,
      default: false,
      required: false
    }
  }
};
</script>

<style>
.v-overlay {
  z-index: 201 !important;
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 20, 50, 0.3);
  backdrop-filter: blur(0.1em);
  z-index: 200;
  transition: 1s;
}
</style>
